import * as React from 'react';
import CandidateShareWF from './CandidateShareWF';

export interface CandidateShareProps { }

export interface CandidateShareState { }

export default class CandidateShare extends React.Component<CandidateShareProps, CandidateShareState> {
    constructor(props: CandidateShareProps) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="col-11 mx-auto rel-notuse mb-3">
                <CandidateShareWF />
            </div>
        );
    }
}